import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	articlesPageHeader: {
		id: 'servicedesk.knowledge-hub.common.i18n.articles-page-header',
		defaultMessage: 'Articles',
		description: 'Page header for the all articles page in the JSM knowledge hub',
	},
	knowledgeBase: {
		id: 'servicedesk.knowledge-hub.common.i18n.knowledge-base',
		defaultMessage: 'Knowledge base',
		description: 'Title of the knowledge feature, used in breadcrumbs, sidebar items, etc',
	},
	noCategoryText: {
		id: 'servicedesk.knowledge-hub.common.i18n.no-category-text',
		defaultMessage: 'Uncategorized',
		description:
			'Text we show in place of a list of categories if the articles does not belong to any category',
	},
	editInConfluence: {
		id: 'servicedesk.knowledge-hub.common.i18n.edit-in-confluence',
		defaultMessage: 'Edit in Confluence',
		description: 'Call to action to edit article in Confluence',
	},
});
